<template>
    <v-card>
        <v-card-title>
        <span class="headline">Claim Type Detail</span>
      </v-card-title>
      <v-card-text>
        <message :messages="messages"></message>
        <form>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 sm6 v-if="mode === 'new'">
                <v-autocomplete :items="appIdList" v-model="selectedClmTypeDet.appId" :label="labels.appId" item-text="label" item-value="value"
                  data-vv-name="appId" :data-vv-as="labels.appId" :error-messages="errors.collect('appId')" v-validate="'required'"
                  @change="selectedClmTypeDet.clmType=undefined;selectedClmTypeDet.clmSubType=undefined"/>
              </v-flex>
              <v-flex xs12 sm6 v-if="mode === 'review' || mode === 'query'">
                <v-subheader class="queryLabel">{{labels.appId}}</v-subheader>
                <div class="title">{{appId[selectedClmTypeDet.appId]}}</div>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete v-if="mode === 'new'" v-model="selectedClmTypeDet.clmType" :label="labels.clmType" :error-messages="errors.collect('clmType')" v-validate="'required'"
                  data-vv-name="clmType" :data-vv-as="labels.clmType" :items="filteredClmTypeList" item-text="label" item-value="clmType" :loading="loading"
                  @change="generateSubTypeList();generateOnValList();selectedClmTypeDet.clmSubType=undefined"/>
                <v-subheader v-if="mode === 'review' || mode === 'query'" class="queryLabel">{{labels.clmType}}</v-subheader>
                <div v-if="mode === 'review' || mode === 'query'" class="title">{{clmTypeMap[selectedClmTypeDet.clmType]}}</div>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete v-if="mode === 'new'" v-model="selectedClmTypeDet.clmSubType" :label="labels.clmSubType" :error-messages="errors.collect('clmSubType')" v-validate="'required'"
                  data-vv-name="clmSubType" :data-vv-as="labels.clmSubType" :items="filteredClmSubTypeList" item-text="label" item-value="clmSubType" :loading="loadingSub" @change="generateOnValList();generateQryRefList();"/>
                <v-subheader v-if="mode === 'review' || mode === 'query'" class="queryLabel">{{labels.clmSubType}}</v-subheader>
                <div v-if="mode === 'review' || mode === 'query'" class="title">{{clmSubTypeMap[selectedClmTypeDet.clmSubType]}}</div>
              </v-flex>
              <v-flex xs12 sm6>
                <v-autocomplete v-if="mode === 'new'" v-model="selectedClmTypeDet.lvlNo" :label="labels.lvlNo" :error-messages="errors.collect('lvlNo')" data-vv-name="lvlNo"
                  v-validate="'required'" :data-vv-as="labels.lvlNo" :items="lvlNoList" item-text="label" item-value="value" @change="generateOnValList();generateQryRefList();"/>
                <v-subheader v-if="mode === 'review' || mode === 'query'" class="queryLabel">{{labels.lvlNo}}</v-subheader>
                <div v-if="mode === 'review' || mode === 'query'" class="title">{{selectedClmTypeDet.lvlNo}}</div>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field v-if="mode === 'new' && selectedClmTypeDet.lvlNo === 1" v-model="selectedClmTypeDet.qryRef" :label="labels.qryRef" :error-messages="errors.collect('qryRef')" v-validate="'required|max:4'"
                  data-vv-name="qryRef" :data-vv-as="labels.qryRef"/>
                <v-autocomplete v-if="mode === 'new' && selectedClmTypeDet.lvlNo === 2" v-model="selectedClmTypeDet.qryRef" :label="labels.qryRef" :error-messages="errors.collect('qryRef')" v-validate="'required|max:4'"
                  data-vv-name="qryRef" :data-vv-as="labels.qryRef" :items="filteredClmTypeDets" item-text="qryRef" item-value="qryRef" @change="generateOnValList"/>
                <v-subheader v-if="mode === 'review' || mode === 'query'" class="queryLabel">{{labels.qryRef}}</v-subheader>
                <div v-if="mode === 'review' || mode === 'query'" class="title">{{selectedClmTypeDet.qryRef}}</div>
              </v-flex>
              <v-flex xs12 sm6>
                <v-autocomplete v-if="mode === 'new'" v-model="selectedClmTypeDet.onVal" :label="labels.onVal" :error-messages="errors.collect('onVal')" data-vv-name="onVal"
                  v-validate="{ required: !disableOnVal }" :data-vv-as="labels.onVal" :items="onValList" item-text="label" item-value="value" :disabled="disableOnVal" />
                <v-subheader v-if="mode === 'review' || mode === 'query'" class="queryLabel">{{labels.onVal}}</v-subheader>
                <div v-if="mode === 'review' || mode === 'query'" class="title">{{selectedClmTypeDet.onVal}}</div>
              </v-flex>
              <v-flex xs12 sm6>
                <v-autocomplete v-if="mode === 'new'" v-model="selectedClmTypeDet.seqNo" :label="labels.seqNo" :error-messages="errors.collect('seqNo')" data-vv-name="seqNo"
                  v-validate="'required'" :data-vv-as="labels.seqNo" :items="seqNoList" item-text="label" item-value="value" />
                <v-subheader v-if="mode === 'review' || mode === 'query'" class="queryLabel">{{labels.seqNo}}</v-subheader>
                <div v-if="mode === 'review' || mode === 'query'" class="title">{{selectedClmTypeDet.seqNo}}</div>
              </v-flex>
              <v-flex xs12 md12>
                <v-text-field v-if="mode === 'review' || mode === 'new'" v-model="selectedClmTypeDet.qryRefDesc" :label="labels.qryRefDesc" :error-messages="errors.collect('qryRefDesc')" v-validate="'required|max:200'"
                  data-vv-name="qryRefDesc" :data-vv-as="labels.qryRefDesc"/>
                <v-subheader v-if="mode === 'query'" class="queryLabel">{{labels.qryRefDesc}}</v-subheader>
                <div v-if="mode === 'query'" class="title">{{selectedClmTypeDet.qryRefDesc}}</div>
              </v-flex>
              <v-flex xs12 sm6>
                <v-autocomplete v-if="mode === 'review' || mode === 'new'" v-model="selectedClmTypeDet.fldForm" :label="labels.fldForm" :error-messages="errors.collect('fldForm')" v-validate="'required'"
                  data-vv-name="fldForm" :data-vv-as="labels.fldForm" :items="fldFormList" item-text="label" item-value="value" clearable />
                <v-subheader v-if="mode === 'query'" class="queryLabel">{{labels.fldForm}}</v-subheader>
                <div v-if="mode === 'query'" class="title">{{fldFormMap[selectedClmTypeDet.fldForm]}}</div>
              </v-flex>
              <v-flex xs6 md3>
                <v-checkbox :readonly="mode === 'query'" v-model="selectedClmTypeDet.isMand" :label="labels.isMand" data-vv-name="isMand" :data-vv-as="labels.isMand"
                  :error-messages="errors.collect('isMand')"/>
              </v-flex>
              <v-flex xs6 md3>
                <v-checkbox :readonly="mode === 'query'" v-model="selectedClmTypeDet.isLossDt" :label="labels.isLossDt" data-vv-name="isLossDt" :data-vv-as="labels.isLossDt"
                  :error-messages="errors.collect('isLossDt')" v-if="selectedClmTypeDet.fldForm === 'D' || selectedClmTypeDet.fldForm === 'O'"/>
              </v-flex>
              <v-flex xs12 md12>
                <v-text-field v-if="(mode === 'review' || mode === 'new') && requirePermVal" v-model="selectedClmTypeDet.permVal" :label="labels.permVal" :error-messages="errors.collect('permVal')"
                  v-validate="'required|max:100'" data-vv-name="permVal" :data-vv-as="labels.permVal"/>
                <v-subheader v-if="mode === 'query' && requirePermVal" class="queryLabel">{{labels.permVal}}</v-subheader>
                <div v-if="mode === 'query'" class="title">{{selectedClmTypeDet.permVal}}</div>
              </v-flex>
              <v-flex xs12 sm6>
                <v-autocomplete v-if="mode === 'review' || mode === 'new'" v-model="selectedClmTypeDet.fldLookup" :label="labels.fldLookup" :error-messages="errors.collect('fldLookup')"
                  data-vv-name="fldLookup" :data-vv-as="labels.fldLookup" :items="fldLookupList" item-text="label" item-value="value" clearable />
                <v-subheader v-if="mode === 'query'" class="queryLabel">{{labels.fldLookup}}</v-subheader>
                <div v-if="mode === 'query'" class="title">{{selectedClmTypeDet.fldLookup}}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" flat @click.native="doCancel" :disabled="submitting">Cancel</v-btn>
        <v-btn color="primary" v-if="mode === 'review' || mode === 'new'" flat @click.native="doSave" :loading="submitting">Save</v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'

export default {
  props: {
    'selectedClmTypeDet': Object,
    'mode': String,
    'clmTypeDets': Array
  },
  data() {
    return {
      labels: {
        appId: 'Module',
        clmType: 'Claim Type*',
        clmSubType: 'Claim Sub Type*',
        qryRef: 'Query Reference*',
        lvlNo: 'Level No.*',
        onVal: 'On value*',
        qryRefDesc: 'Description*',
        seqNo: 'Sequence No.*',
        isMand: 'Mandatory',
        isLossDt: 'Date of Loss/Incident',
        fldForm: 'Format*',
        permVal: 'Permitted Values (e.g "Y-Yes,N-No")',
        fldLookup: 'Lookup'
      },
      clmTypeList: [],
      clmTypeMap: {},
      clmSubTypeList: [],
      clmSubTypeMap: {},
      filteredClmSubTypeList: [],
      filteredClmTypeDets: [],
      seqNoList: [],
      appId: {
        'TR': 'Travel',
        'MD': 'Maid',
        'FI': 'Fire'
      },
      lvlNoList: [
        { label: '1', value: 1 },
        { label: '2', value: 2 }
      ],
      onValList: [
      ],
      fldFormList: [
        { label: 'Date', value: 'D' },
        { label: 'Datetime', value: 'O' },
        { label: 'Text', value: 'T' },
        { label: 'Checkbox', value: 'C' },
        { label: 'Numeric', value: 'N' },
        { label: 'Monetary/Currency', value: 'P' }
      ],
      fldFormMap: {
        D: 'Date',
        T: 'Text',
        C: 'Checkbox',
        N: 'Numeric'
      },
      noCopiesList: [
        { label: 'Single', value: 'S' },
        { label: 'Multiple', value: 'M' }
      ],
      fldLookupList: [
        { label: 'Calendar', value: 'Calendar', appliesTo: [ 'D' ] },
        { label: 'Country', value: 'Country', appliesTo: [ 'T' ] }
      ],
      loading: false,
      loadingSub: false,
      submitting: undefined
    }
  },
  created() {
    this.seqNoList = []
    for (var i = 1; i < 31; i++) {
      this.seqNoList.push({ label: '' + i, value: i })
    }
  },
  computed: {
    appIdList() {
      let result = []
      let appID = this.appId
      Object.keys(appID).forEach(function (key) {
        const status = appID[key]
        result.push({
          label: key + ' - ' + status,
          value: key
        })
      })
      return result
    },
    filteredClmTypeList() {
      return this.clmTypeList.filter(x => {
        return x.appId === this.selectedClmTypeDet.appId
      })
    },
    disableOnVal() {
      return this.selectedClmTypeDet.lvlNo === 1
    },
    requirePermVal() {
      return this.selectedClmTypeDet.fldForm === 'C'
    }
  },
  mounted() {
    this.doInit()
  },
  methods: {
    doInit() {
      this.loadClaimTypes()
      this.loadClaimSubTypes()
      this.generateOnValList()
      this.resetMessages()
    },
    async loadClaimTypes() {
      this.loading = true
      const apiUrl = this.$store.state.claimParam.menu.getClmTypes
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            this.clmTypeList = []
            data.map((clmType) => {
              clmType.label = clmType.clmType + ' - ' + clmType.clmTypeDesc
              this.clmTypeMap[clmType.clmType] = clmType.label
              this.clmTypeList.push(clmType)
            })
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Unable to retrieve claim types (Missing API URL)')
      }
      this.loading = false
    },
    async loadClaimSubTypes() {
      this.loadingSub = true
      const apiUrl = this.$store.state.claimParam.menu.getClmSubTypes
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            this.clmSubTypeList = []
            data.map((clmSubType) => {
              clmSubType.label = clmSubType.clmSubType + ' - ' + clmSubType.clmSubTypeDesc
              this.clmSubTypeMap[clmSubType.clmSubType] = clmSubType.label
              this.clmSubTypeList.push(clmSubType)
            })
            this.loadingSub = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loadingSub = false
        }
      } else {
        this.$snotify.error('Unable to retrieve claim sub types (Missing API URL)')
      }
      this.generateSubTypeList()
      this.loadingSub = false
    },
    generateSubTypeList() {
      const filteredClmSubTypeList = []
      this.filteredClmSubTypeList = filteredClmSubTypeList
      const clmType = this.selectedClmTypeDet.clmType
      if (clmType && this.clmSubTypeList) {
        this.clmSubTypeList.forEach(function(clmSubType) {
          if (clmSubType.clmType === clmType) {
            filteredClmSubTypeList.push(clmSubType)
          }
        })
      }
    },
    generateQryRefList() {
      this.filteredClmTypeDets = []
      const appId = this.selectedClmTypeDet.appId
      const clmType = this.selectedClmTypeDet.clmType
      const clmSubType = this.selectedClmTypeDet.clmSubType
      const lvlNo = this.selectedClmTypeDet.lvlNo
      if (!appId || !clmType || !clmSubType || lvlNo === 1) {
        return
      }
      for (const clmTypeDet of this.clmTypeDets) {
        if (clmTypeDet.lvlNo === 1 &&
          clmTypeDet.appId === appId &&
          clmTypeDet.clmType === clmType &&
          clmTypeDet.clmSubType === clmSubType &&
          clmTypeDet.fldForm === 'C') {
          this.filteredClmTypeDets.push(clmTypeDet)
        }
      }
      if (this.filteredClmTypeDets.length === 0) {
        this.$snotify.error('No valid level 1 claim type detail found for this subtype')
      }
    },
    generateOnValList() {
      const appId = this.selectedClmTypeDet.appId
      const clmType = this.selectedClmTypeDet.clmType
      const clmSubType = this.selectedClmTypeDet.clmSubType
      const qryRef = this.selectedClmTypeDet.qryRef
      const parentLvl = this.selectedClmTypeDet.lvlNo - 1 || 0
      const onValList = []
      this.onValList = onValList
      let permVal = ''
      if (appId && clmType && clmSubType && qryRef && parentLvl > 0 && this.clmTypeDets) {
        for (const clmTypeDet of this.clmTypeDets) {
          if (clmTypeDet.appId === appId &&
            clmTypeDet.clmType === clmType &&
            clmTypeDet.clmSubType === clmSubType &&
            clmTypeDet.qryRef === qryRef &&
            clmTypeDet.lvlNo === parentLvl) {
            if (clmTypeDet.fldForm === 'C') {
              permVal = clmTypeDet.permVal
              break
            } else {
              this.$snotify.error('Level No. more than 1 not permitted (00134)')
              return
            }
          }
        }
        if (permVal) {
          const permVals = permVal.split(',')
          for (const val of permVals) {
            const splitVal = val.split('-')
            if (splitVal.length === 2) {
              const option = {
                value: splitVal[0],
                label: splitVal[0] + ' - ' + splitVal[1]
              }
              onValList.push(option)
            } else {
              this.$snotify.warn('Invalid permitted value format ' + val)
            }
          }
        } else {
          this.$snotify.error('Invalid Level No. (100039)')
        }
      }
    },
    validatePermVal() {
      if (this.selectedClmTypeDet.permVal) {
        const permVal = this.selectedClmTypeDet.permVal
        const permVals = permVal.split(',')
        for (const val of permVals) {
          const splitVal = val.split('-')
          if (splitVal.length === 2) {
            if (splitVal[0].length > 10) {
              this.$snotify.error('PermVal key: ' + splitVal[0] + ' exceeds length of 10 allowed')
              return false
            }
          } else {
            this.$snotify.error('Invalid permitted key-value format "' + val + '"')
            return false
          }
        }
      }
      return true
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.validatePermVal()) {
            if (this.mode === 'new') this.doCreate()
            if (this.mode === 'review') this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.$store.state.claimParam.menu.createClmTypeDet
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.selectedClmTypeDet)
          const { data } = result
          if (data.qryRef) {
            this.notify(data)
            this.$emit('fetchData')
            this.$emit('close')
          } else {
            this.notify(data)
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      }
    },
    async doUpdate() {
      const apiURI = this.$store.state.claimParam.menu.updateClmTypeDet
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.selectedClmTypeDet)
          const { data } = result
          if (data.qryRef) {
            this.notify(data)
            this.$emit('fetchData')
            this.$emit('close')
          } else {
            this.notify(data)
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    doCancel() {
      this.resetMessages()
      this.$emit('close')
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
